/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const { version } = require('../package.json');

if (environment.sentry.enabled) {
  Sentry.init({
    release: `zeus-web@${version}`,
    dsn: environment.sentry.dsn,
    environment: environment.env,
    tracePropagationTargets: ['localhost', environment.serverUrl, '/^//'],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: Number(environment.sentry.sampleRate),
    replaysSessionSampleRate: Number(environment.sentry.replaysSessionSampleRate),
    replaysOnErrorSampleRate: Number(environment.sentry.replaysOnErrorSampleRate),
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
